import Axios from 'axios'
import config from '../config'
import * as ponctual from './inquiries/ponctual'
import * as maintenance from './inquiries/maintenance'
import { toInquiry } from './inquiries/adapters'

export const InquiryPaths = {
  MAINTENANCE: 'maintenance/',
  VISIT: 'visits',
  REALISATION: 'realisations'
}

export const list = async ({ frequency, type }) => {
  const URL = `${config.baseURL}${config.apiURL}customers/${InquiryPaths[frequency] || ''}${InquiryPaths[type]}?&sort=createdDate,DESC`
  const response = await Axios.get(URL)
  // On récupère le name ici
  const name = response.data.content.map((i) => i.type)
  const content = response.data.content.map(toInquiry(type))
  return { ...response.data, content, name }
}

export {
  ponctual,
  maintenance
}



// WEBPACK FOOTER //
// ./src/api/inquiries.js